/**
 * Display-mapper do status por critério (E25.F3 / ADR-0035). // ux-neutrality:allow doc-comment
 *
 * O STATUS vem resolvido do backend (`criteria_status` no payload do // ux-neutrality:allow doc-comment
 * workspace — banda canônica [1/3, 3]); este módulo só mapeia chave → nome // ux-neutrality:allow doc-comment
 * PT-BR e oferece o fallback de leitura. A régua client-side (≥1,5/≤0,67) // ux-neutrality:allow doc-comment
 * que vivia aqui foi removida (lição F-E16.F2-01: o front não deriva // ux-neutrality:allow doc-comment
 * status de LR). Consumido pela CriteriaPanel (badge) E pela marcação na // ux-neutrality:allow doc-comment
 * questionada (ContestedMarkerOverlay), que concordam por construção. // ux-neutrality:allow doc-comment
 */
import { ptBR } from '@/i18n/pt-BR';
import type { CriterionBandStatus } from '@/lib/case_workspace';

export type DerivedStatus = CriterionBandStatus;

/**
 * Lê o status do critério vindo do payload; `neutral` quando o backend não
 * enviou (análise sem breakdown — nunca fabrica convergência/divergência).
 */
export function criterionStatusFrom(
  criteriaStatus: Record<string, CriterionBandStatus> | null | undefined,
  key: string,
): CriterionBandStatus {
  return criteriaStatus?.[key] ?? 'neutral';
}

// Mapeia chave do `criteria_breakdown` (snake_case do backend) → chave do
// dicionário i18n `criterio.nome.*`. Mantém a divergência histórica do crit. 2
// (`inclinacao` no front vs `inclinacao_axial` na calibração).
const _CRITERION_NAME_KEYS: Record<string, keyof typeof ptBR.criterio.nome> = {
  calibre: 'calibre',
  inclinacao: 'inclinacao',
  proporcionalidade: 'proporcionalidade',
  espacamento: 'espacamento',
  velocidade: 'velocidade',
  pressao: 'pressao',
  ataque_remate: 'ataque',
  minimos_graficos: 'minimos',
  gestos_caracteristicos: 'gestos',
  forma_global: 'forma',
};

export function criterionDisplayName(key: string): string {
  const i18nKey = _CRITERION_NAME_KEYS[key];
  if (i18nKey) return ptBR.criterio.nome[i18nKey];
  return key;
}
